import {Accordion, AccordionDetails, Box, Stack, styled} from '@mui/material';

const StyledAccordion = styled(Accordion)`
	border: none;
	box-shadow: none;
`;

const StyledAccordionDetails = styled(AccordionDetails)`
	padding: 0;
`;

const StyledBox = styled(Box)`
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	border-radius: 8px;
`;

const StyledStack = styled(Stack)`
	width: 100%;
	padding: 16px;
`;

export {StyledAccordion, StyledAccordionDetails, StyledBox, StyledStack};
